<mat-list dense cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListData]="items">
  @for (item of items; track item) {
    <item [item]="item" [class.deep-slot]="isDeepSlot($index)" cdkDrag>{{ item }}</item>
  }
  <div class="add-item">
    @if (this.getItems().length < capacity) {
      <button mat-mini-fab (click)="openItemDialog(null,items)" color="primary">
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>
</mat-list>
